import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import { useActiveScopeCentre } from '../../lib/map-centre';
import { MUNICIPALITY_ZOOM } from '../../lib/map-tiles';

/**
 * The opening view for a gov map with nothing of its own to fit to.
 *
 * Every map opens on the whole of New Brunswick (`bounds={NB_BOUNDS}` on the
 * container); this then moves it, once, to the active municipality when the
 * session-centre endpoint knows where that is. A map that has points fits to
 * those instead and passes `hasPoints`, and a person who has already panned is
 * not pulled back. The field map, team map, replay and operations maps all open
 * this way, so none of them shows Moncton to a clerk in Miramichi.
 */
export function OpenOnScope({ hasPoints }: { hasPoints: boolean }) {
  const map = useMap();
  const centre = useActiveScopeCentre();
  const done = useRef(false);
  useEffect(() => {
    if (done.current || hasPoints || !centre.data) return;
    done.current = true;
    map.setView([centre.data.latitude, centre.data.longitude], MUNICIPALITY_ZOOM);
  }, [map, hasPoints, centre.data]);
  return null;
}
